module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soap carving is the skill of carving figures such as beautiful flowers, cute animals, or even pretty accessories like sporty high-tops and handbags in soap using a few basic tools. There are some simple guidelines for cutting the soap to create the petals and patterns, but they’re easy to follow, allowing you to get started quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soap carving differs from sculpture because the patterns in the soap aren’t carved freely. Instead, you’ll use the templates supplied in this book to create your designs. You’ll start by carving the soap along the outlines of the template to create the basic shape and then fill in the details to bring the figure to life. Using these templates means that anyone can successfully carve the projects in this book. You’ll be amazed at what you can create with only a knife and a bar of soap—and how much fun you’ll have doing it!")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "blev521"
    }
  }, [_vm._v("A BRIEF HISTORY OF SOAP CARVING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Soap carving is based on traditional fruit- and vegetable-carving techniques from Thailand. These techniques were developed in the palaces of Thai kings more than 700 years ago. Using these techniques, court ladies would use a long, pointed knife to carve beautiful flowers and animals in fruits and vegetables, such as watermelons, honeydew melons, papayas, carrots, and pumpkins.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though fruit and vegetable carving began as an art of the palace, it spread among ordinary Thai people in modern times. According to Nidda Hongwiwat’s book, Vegetable and Fruit Carving, in the 1930s a school of home economics was established, with fruit and vegetable carving among the courses taught. Many teachers throughout Thailand enrolled in a year-long training course, which allowed the craft to spread widely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because the carved fruits and vegetables don’t last long, though, some artists replaced them with bar soap. Though the medium has changed, the traditional techniques are still used.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carving using both soap and fruit and vegetables as a medium spread to Japan and has become increasingly popular over the last twenty years. Because fruits such as watermelon and papaya aren’t affordable in Japan—its climate isn’t tropical—soap carving is a popular alternative to carving with tropical fruits.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6"
    }
  }), _c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "blev522"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }, [_vm._v("USING CARVED SOAP")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you’ve created your mini-masterpiece, you can use it in a number of ways.")])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Treat yourself!")]), _vm._v(" You can use your carved soap just as you would regular soap. It’s the perfect way to pamper yourself on a daily basis. I like using handmade soap, and I started soap carving because I wanted to carve beautiful flowers and delicate patterns in the handmade soap I was already using.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Make special gifts for family and friends.")]), _vm._v(" Cute soaps make great, inexpensive gifts for any occasion, including birthdays, graduations, weddings, and other celebrations. Give a hand-carved bar to cheer up a sick friend or welcome a new neighbor to the community. Invited to a dinner party? Instead of a bottle of wine or box of chocolates, surprise your hosts with a beautiful bar of hand-carved soap. Your family and friends will appreciate the unique gift and the fact that you made it yourself.")])]), _c('p', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Use the carved soap in an arrangement.")]), _vm._v(" You can make stunning flower arrangements with your carved soap flowers. Arrange the soap flowers like real flowers in a small pot or vase. You can also make an adorable flower wreath with your carved soap flowers (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch3#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0007-01",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "blev523"
    }
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_vm._v("BENEFITS OF SOAP CARVING")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’re wondering if soap carving is for you, consider the following:")])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("It’s an inexpensive hobby that doesn’t require a lot of tools or special materials.")]), _vm._v(" Of course, you’ll need soap (you’ll find guidance on selecting the best choices for carving in ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#ch1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v("), and you’ll also want to invest in a quality carving knife, which will make your hobby much easier and more fun. After that, there are just a few additional tools—some of which you likely already own—that will help you to do the finer carving and sculpting work.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("It’s good for you!")]), _vm._v(" Bar soap is softer than other carving materials such as wood and stone, so it can be cut and carved smoothly and easily. Because of this, many people find soap carving relaxing. It’s a great way to unwind after a busy day, and the act of focusing on the soap and the figure you’re creating can be meditative and peaceful.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("You can use your carving skills on other mediums.")]), _vm._v(" Once you learn the technique of soap carving, you can use these same skills to carve beautiful flowers and pretty animals out of fruits and vegetables. Try carving a watermelon or honeydew melon into a fun shape to create a unique centerpiece for your table at your next party!")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("You can sell your creations.")]), _vm._v(" If you find that you really enjoy soap carving, you might want to consider turning your hobby into a small business. Soap flower arrangements, in particular, are often very popular items to sell. A small stand at a farmers’ market selling your carved soaps could become a unique and popular stop for customers.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "blev524"
    }
  }, [_vm._v("ADVANTAGES OF CARVING SOAP VERSUS MOLDING SOAP")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you want to make cute soap, you could use a mold rather than a carving knife. It’s easy to make cute soap with a mold, but there are some distinct advantages to carving soap.")])]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("If you can do soap carving, you can use those same skills to carve fruits and vegetables, too.")]), _vm._v(" On the other hand, although you can make a rose-shaped soap with a mold, you can’t make a carrot rose and a potato rose. This is the most important difference. In addition to the fruits and vegetables, soft candles can be carved in the same way as soap. Soft candles are made for carving.")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("When you carve soap, you can make your desired shape in different sizes according to your preference")]), _vm._v(", such as a small or large rose or leaf. (Each template in this book comes in two sizes for this reason.) With a soap mold, you’re limited to the size of the mold. With soap carving, you can also carve letters in the soap, which allows you to add initials, names, or messages. You can even use your carving skills to customize molded or store-bought soap. Some people make a giant soap bar to carve a large object.")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "blist"
  }, [_vm._v("• "), _c('strong', [_vm._v("You can carve not only store-bought soap, but also handmade soap and molded soap.")]), _vm._v(" However, molded soap is usually made with melt-and-pour soap, which is similar to glycerin soap. It’s easy to make cute soap with melt-and-pour soap, but melt-and-pour soap doesn’t lather well and it has weaker cleansing power. This is why commercial opaque soap and handmade soap are more commonly used than melt-and-pour soap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ready to begin? Turn the page for an introduction to the materials and tools you’ll need to start making your very own fun and unique carved soaps.")]), _vm._v(" "), _c('div', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0009-01",
      "src": "images/f0009-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 69
// module chunks = 0